import { render } from "./IconOrderReports.vue?vue&type=template&id=3a8b3c2c"
import script from "./IconOrderReports.vue?vue&type=script&lang=js"
export * from "./IconOrderReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__